// Turn a WizardConnect-delivered xpub + child index into a cashaddr.
// Uses libauth: compressed pubkey → hash160 → P2PKH locking bytecode → cashaddr.
// Chipnet uses the `bchtest:` prefix (shared with testnet4 for this shell); a
// mainnet build would swap to `bitcoincash:`.

import {
  ripemd160,
  sha256,
  encodeCashAddress,
  CashAddressType,
  CashAddressNetworkPrefix,
} from '@bitauth/libauth';

export type Network = 'chipnet' | 'mainnet';

/** hash160(compressed pubkey) — the 20-byte PKH. */
export function pkhOfPubkey(pubkey: Uint8Array): Uint8Array {
  return ripemd160.hash(sha256.hash(pubkey));
}

/** Compressed pubkey → cashaddr string (bchtest: / bitcoincash:). */
export function cashaddrFromPubkey(pubkey: Uint8Array, network: Network): string {
  const pkh = pkhOfPubkey(pubkey);
  const prefix = network === 'chipnet'
    ? CashAddressNetworkPrefix.testnet    // chipnet + testnet share the bchtest: prefix
    : CashAddressNetworkPrefix.mainnet;
  const res = encodeCashAddress({ prefix, type: CashAddressType.p2pkh, payload: pkh });
  // libauth returns either a string or { address, prefix, ... } depending on the version;
  // handle both to stay resilient.
  if (typeof res === 'string') return res;
  // @ts-expect-error runtime shape check
  return res.address ?? String(res);
}
